import styled from 'styled-components'
import { SCREEN_MEDIUM_TABLE, SCREEN_MOBILE } from '../../lib/const/breakpoint'
import { mediaQuery } from '../../lib/service/service'

const FooterSC = styled.footer`
    width: 100%;
    padding: 40px 80px;
    background-image: url('/FooterBG.webp');
    background-repeat: no-repeat;
    background-size: cover;

    ${mediaQuery(1000)} {
        padding: 30px 15px 20px 15px;
    }
`

const FooterGridSC = styled.div`
    width: 100%;
    max-width: 1540px;
    margin: 0 auto;

    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 24px;
    row-gap: 25px;
    align-items: start;

    ${mediaQuery(1000)} {
        grid-template-columns: 1fr;
        row-gap: 15px;
    }
`

const FooterCellSC = styled.div`
    min-width: 0;
    justify-self: ${({ $justify }) => $justify || 'stretch'};
    text-align: ${({ $textAlign }) => $textAlign || 'left'};

    ${mediaQuery(1000)} {
        justify-self: stretch;
        text-align: left;
    }
`

const PartWrapperSC = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${({ $align }) => $align || 'flex-start'};
    width: 100%;
    min-width: 0;

    ${mediaQuery(1000)} {
        align-items: flex-start;
    }
`

const PartTitleSC = styled.h4`
    font-weight: 700;
    font-size: 18px;
    line-height: 148%;
    letter-spacing: 0.02em;
    color: #fdfdfd;
    margin-bottom: 20px;

    ${mediaQuery(1000)} {
        font-size: 14px;
        margin-bottom: 15px;
    }
`

const AddressSC = styled.a`
    transition: all 0.4s;
    display: block;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    color: #b3b3b3;
    max-width: 210px;
    white-space: pre-line;

    &:hover {
        color: #56a2fd;
    }

    ${mediaQuery(1000)} {
        font-size: 14px;
    }

    ${mediaQuery(1000)} {
        font-size: 12px;
    }
`

const CompanySC = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    min-width: 0;

    ${mediaQuery(1000)} {
        flex-direction: column;
        gap: 5px;
    }
`

const CompanyItemSC = styled.span`
    font-weight: 300;
    font-size: 14px;
    line-height: 120%;
    color: #fdfdfd;

    ${mediaQuery(1000)} {
        font-size: 12px;
    }

    ${mediaQuery(1000)} {
        font-size: 10px;
    }
`

const ContactItemSC = styled.a`
    transition: all 0.4s;
    cursor: pointer;
    display: block;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: #b3b3b3;
    max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'none')};
    white-space: normal;
    overflow-wrap: anywhere;

    &:hover {
        color: #56a2fd;
    }

    ${mediaQuery(1000)} {
        font-size: 12px;
    }
`

const SocialWrapperSC = styled.div`
    display: flex;
    gap: 20px;
`

const GrantSC = styled.a`
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    gap: 28px;
    margin-top: 15px;
    padding-top: 25px;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    text-decoration: none;
    cursor: pointer;

    ${mediaQuery(1000)} {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        padding-top: 18px;
    }
`

const GrantLogosSC = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 22px;
    padding: 14px 22px;
    background: #ffffff;
    border-radius: 10px;

    ${mediaQuery(1000)} {
        gap: 16px;
        padding: 12px 16px;
    }
`

const GrantLogoSC = styled.img`
    display: block;
    height: 58px;
    width: auto;

    ${mediaQuery(1000)} {
        height: 44px;
    }
`

const GrantDividerSC = styled.span`
    width: 1px;
    align-self: stretch;
    background: #e0e0e0;
`

const GrantTextSC = styled.span`
    font-weight: 300;
    font-size: 14px;
    line-height: 150%;
    color: #b3b3b3;
    max-width: 640px;
    transition: color 0.4s;

    ${GrantSC}:hover & {
        color: #56a2fd;
    }

    ${mediaQuery(1000)} {
        font-size: 12px;
    }
`

const SocialItemSC = styled.a`
    transition: all 0.4s;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    width: 43px;
    height: 43px;
    border: 1px solid #b3b3b3;
    border-radius: 4px;
    font-weight: 900;
    font-size: 18px;
    line-height: 22px;
    text-transform: uppercase;
    color: #b3b3b3;

    &:hover {
        color: #56a2fd;
        border: 1px solid #56a2fd;
    }

    ${mediaQuery(1000)} {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }
`

export const styleFooter = () => ({
    FooterSC,
    FooterGridSC,
    FooterCellSC,
    AddressSC,
    CompanySC,
    PartTitleSC,
    SocialItemSC,
    CompanyItemSC,
    ContactItemSC,
    PartWrapperSC,
    SocialWrapperSC,
    GrantSC,
    GrantLogosSC,
    GrantLogoSC,
    GrantDividerSC,
    GrantTextSC,
})
